import { getConfig, URLS } from '@constants';

import { getLimitedNumber } from '@utils';

import {
	IFetchAppsResponse,
} from '@api';

import {
	IAppData,
	IAppsData,
	IAppsSalesResponse,
	IAppItemResponse,
	IAppPicturesResponse,
	IAppsSalesItemResponse,
} from '@interfaces';

const MIN_RATING = 0;
const MAX_RATING = 5;

export const getAdaptedApps = (appsResp: IFetchAppsResponse) => {
	let apps: IAppData[] = [];

	if (appsResp && appsResp.data) {
		const appsArr = Array.isArray(appsResp.data) ? appsResp.data : Object.values(appsResp.data);
		apps = appsArr.map((item: IAppItemResponse, i: number) => {
			const getScreenshots = (pics: IAppPicturesResponse) => {
				const hasHtmlScreenshots = !!pics.Screenshot1_Text_HTML;
				return Object.keys(pics)
					.filter((pic: string) => {
						const regExp = hasHtmlScreenshots
							? /^Screenshot[\d]_Text_HTML/g
							: /^Screenshot[\d]/g;
						const matchPic = pic.match(regExp);

						if (!!matchPic) {
							return pic;
						}
					})
					.sort()
					.map((key: string) => pics[key]);
			};

			return {
				id: item.ID,
				title: item.Name,
				titleShort: item.ShortName,
				description: item.Description,
				descriptionShort: item.ShortDescription,
				genres: item.Genre || [],
				installs: item.InstallationsSpaced,
				pics: {
					'630x380': item.Pictures.GameCover,
					'980x370': item.Pictures.BigPic,
					'120x60': item.Pictures.Pic,
					'560x210': item.Pictures.Pic2,
					'143x113': item.Pictures.Pic3,
					'134x104': item.Pictures.Pic4,
					'90x70': item.Pictures.Pic5,
					'ico': item.Pictures.PicIco,
				},
				screenshots: getScreenshots(item.Pictures),
				ref: item.ActiveRef,
				rating: getLimitedNumber(item?.Votes?.Votes1DigitRounded, MIN_RATING, MAX_RATING) || 0,
				voters: item.Votes?.VotesCount || 0,
				communityUrl: item.CommunityURL,
				url: `${getConfig().apps.pathname || URLS.APPS}/${item.ID}`,
			};
		});
	}
	const data: IAppsData = { apps };

	if ('hasMore' in appsResp) {
		data.hasMore = appsResp.hasMore;
	}
	if ('offset' in appsResp) {
		data.offset = appsResp.offset;
	}
	if ('total' in appsResp) {
		data.total = appsResp.total;
	}

	return data;
};

export const getAdaptedSales = (appsResp: IAppsSalesResponse) => {
	let apps: IAppData[] = [];

	if (appsResp && appsResp.data) {
		const appsArr = Array.isArray(appsResp.data) ? appsResp.data : Object.values(appsResp.data);
		apps = appsArr.map((item: IAppsSalesItemResponse, i: number) => {
			const view = item.view;
			return {
				id: view.ID,
				title: item.name || view.Name,
				description: item.desc || view.Description,
				ref: view.ActiveRef,
				rating: 0,
				pics: {
					'630x380': view.Pictures.GameCover,
					'980x370': view.Pictures.BigPic,
					'120x60': view.Pictures.Pic,
					'560x210': item.pic || view.Pictures.Pic2,
					'143x113': view.Pictures.Pic3,
					'134x104': view.Pictures.Pic4,
					'90x70': view.Pictures.Pic5,
					'ico': view.Pictures.PicIco,
				},
				url: `${getConfig().apps.pathname || URLS.APPS}/${view.ID}`,
			};
		});
	}

	return {
		apps,
		unread: appsResp.unread,
		offset: appsResp.offset,
	};
};
